import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import * as styles from "./formSection.module.css";
import { Button, TextField, Typography } from "@mui/material";

const FormSection = ({ footerNode }) => {
  return (
    <Box
      pl={{ xs: 2, sm: 5, md: 15 }}
      pr={{ xs: 2, sm: 5, md: 15 }}
      pt={3}
      pb={3}
      className={styles.sectionBg}
    >
      <Grid container spacing={2} justifyContent="center">
        {footerNode.sectionText ? (
          <Grid item md={6} sm={6} xs={12} className={styles.noteGrid}>
            <Typography className={styles.text}>
              {footerNode.sectionText}
            </Typography>
          </Grid>
        ) : null}
        <Grid item md={6} sm={6} xs={12}>
          <Grid container spacing={1}>
            {footerNode.inputPlaceholder ? (
              <Grid item md={5} sm={12} xs={12}>
                <TextField
                  id="standard-basic"
                  label={footerNode.inputPlaceholder}
                  variant="standard"
                />
              </Grid>
            ) : null}
            {footerNode.buttonText ? (
              <Grid item md={4} sm={12} xs={12}>
                <Button variant="contained" className={styles.btn}>
                  {footerNode.buttonText}
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormSection;
